/** Display-only floor labels. Never changes the underlying scope name or grouping. */
export function floorScopeLabel(label: string): string | null {
  const ground = label.match(/\b(?:(lower|upper)\s+)?ground[\s-]+floor\b/i);
  if (ground) {
    const prefix = ground[1]?.toLowerCase();
    return prefix ? `${prefix === "lower" ? "Lower" : "Upper"} Ground Floor` : "Ground Floor";
  }

  const ordinals = ["first", "second", "third", "fourth", "fifth", "sixth", "seventh", "eighth", "ninth", "tenth"];
  const match = label.match(/\b(first|second|third|fourth|fifth|sixth|seventh|eighth|ninth|tenth|\d+(?:st|nd|rd|th)?)[\s-]+floor\b/i);
  const numbered = label.match(/\bfloor\s+(\d+)\b/i);
  if (!match && !numbered) return null;

  const value = (match?.[1] ?? numbered![1]).toLowerCase();
  const wordIndex = ordinals.indexOf(value);
  const floor = wordIndex >= 0 ? wordIndex + 1 : parseInt(value, 10);
  if (floor === 0) return "Floor 0";
  const lastTwo = floor % 100;
  const suffix = lastTwo >= 11 && lastTwo <= 13 ? "th" : ({ 1: "st", 2: "nd", 3: "rd" } as Record<number, string>)[floor % 10] ?? "th";
  return `${floor}${suffix} Floor`;
}
